import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import Maestro from '../../../util/maestro/maestro';

class ExternalLink extends Component {
	render() {
		const {
			className,
			disableExternalLinks,
			href,
			target
		} = this.props;

		const dataTracking = this.props['data-tracking'];

		return (
			<span>
				{disableExternalLinks
					? <span className={className}>{this.props.children}</span>
					: <a href={href}
							data-tracking={dataTracking}
							className={className}
							target={target}
						>
							{this.props.children}
						</a>
				}
			</span>
		);
	}
}

ExternalLink.propTypes = {
	children: PropTypes.element.isRequired,
	className: PropTypes.string,
	'data-tracking': PropTypes.string,
	disableExternalLinks: PropTypes.bool.isRequired,
	href: PropTypes.string.isRequired,
	target: PropTypes.string
};

function mapStateToProps(state) {
  const {
    disableExternalLinks
  } = Maestro.conduct(state);

  return {
    disableExternalLinks
  };
}

export default connect(
  mapStateToProps
)(ExternalLink);



/** WEBPACK FOOTER **
 ** ./client/components/Common/ExternalLink/ExternalLink.jsx
 **/